import { ResultList as HeadlessResultList, Result } from '@coveo/headless';
import { useEffect, useState, FunctionComponent } from 'react';
// import {Quickview} from '../quickview/quickview.fn';
import { ResultLink } from './result-link';
import React from 'react';

interface ResultListProps {
	controller: HeadlessResultList;
	filterBy?: {
		property: string;
		value: any;
	};
	resultsView?: string;
	limit?: number;
	offset?: number;
}

export const ResultList: FunctionComponent< ResultListProps > = ( props ) => {
	const { controller, filterBy, resultsView, limit, offset } = props;
	const [
		state,
		setState,
	] = useState( controller.state );

	useEffect( () => controller.subscribe( () => setState( controller.state ) ), [] );

	let filteredResults = filterBy ? state.results.filter( ( result ) => result.raw[ filterBy.property ] === filterBy.value ) : state.results;

	if ( limit && offset ) {
		filteredResults = filteredResults.slice( offset, offset + limit );
	} else if ( limit ) {
		filteredResults = filteredResults.slice( 0, limit );
	} else if ( offset ) {
		filteredResults = filteredResults.slice( offset );
	}

	if ( ! filteredResults.length ) {
		return null;
	}

	return (
		<>
			{ filteredResults.map( ( result: Result ) => {
				// Convert the number to a Date object
				const date = new Date( result.raw[ 'date' ] as number );

				// Format the date using toLocaleDateString
				const formattedDate = date.toLocaleDateString( 'en-US', {
					year: 'numeric',
					month: 'long',
					day: 'numeric',
				} );

				// console.log( result );

				return (
					<div key={ result.uniqueId } className="coveo-advanced-query__result">
						{ typeof result?.raw?.imagepreview === 'string' && (
							<figure className="coveo-advanced-query__result-media">
								<img
									src={ result.raw.imagepreview as string }
									alt=""
									className="attachment-medium size-medium"
									decoding="async"radioGroup=''
									width={ 300 }
									height={ 300 }
								/>
							</figure>
						) }
						<div className="coveo-advanced-query__result-content">
							<p className="coveo-advanced-query__result-uri">
								{ result.clickUri }
							</p>
							<h3 className="coveo-advanced-query__result-title has-h5-variant">
								<ResultLink result={ result }>
									{ result.title }
								</ResultLink>
							</h3>
							<div className="coveo-advanced-query__result-excerpt">
								{ result.excerpt }
							</div>
							{/* <p className="coveo-advanced-query__date">{ formattedDate }</p> */}
						</div>
					</div>
				);
			} ) }
		</>
	);
};

// usage

/**
 * ```tsx
 * const controller = buildResultList(engine);
 *
 * <ResultList controller={controller} />;
 * ```
 */
